import { translateService } from "../../services/imports";

// A signer match (vsys SignerMatchingCriteria, delta 7): the criteria one of
// the sharer's signing tools must meet - { anyOf: [{ method?, verification? }] },
// any one alternative is enough, and an alternative matches when every member
// it gives does. Only an integration client gives one; the share dialog keeps
// signing tools and kinds and never makes criteria, it shows and keeps them.

const word = (group, value) => translateService.t(`signerMatch.${group}.${value}`) || value;

// one alternative: "remote signature verified by face", "Georgian eID card",
// or, with a verification alone, "any signing tool verified by face"
const alternative = (a) => {
  const method = a && a.method ? word("method", a.method) : null;
  const verification = a && a.verification ? word("verification", a.verification) : null;
  if (method && verification) return translateService.t("signerMatch.both", method, verification);
  if (method) return method;
  return verification ? translateService.t("signerMatch.anyMethod", verification) : "";
};

// the criteria as text, the alternatives joined with "or"; "" for none
export const describeSignerMatch = (match) =>
  ((match && match.anyOf) || [])
    .map(alternative)
    .filter(Boolean)
    .join(translateService.t("signerMatch.or"));
